import UserAvatar from "../components/common/UserAvatar";

const columns = [
    {
        title: 'User',
        dataIndex: 'user',
        render: (_, record) => (
            <UserAvatar
                data={{
                    name: record?.name,
                    email: record?.email,
                    profile_image: record?.profilePic,
                }}
            />
        ),
    },
    {
        title: 'User Type',
        dataIndex: 'userType',
    },
    {
        title: 'Commision',
        dataIndex: 'totalIBCommission',
        render: (value) => `$ ${value || 0}`,
    },
];

export default columns;